// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"638e4ec5","172":"1bde4887","678":"aa5cb157"}[chunkId] + ".chunk.css";
};